/// <reference path='../userDefinedControls.module.ts' />
/// <reference path='../../../../../typings/index.d.ts' />

module Meevo.Plugins.UserDefinedControls {

    import AppAreaEnum = Meevo.Model.AppAreaEnum;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import IUserDefinedControl = Meevo.Model.IUserDefinedControl;
    import IAppAreaTab = Meevo.Model.IAppAreaTab;
    import IBusinessType = Meevo.Model.IBusinessType;
    import IAppAreaService = Meevo.Model.IAppAreaService;
    import UserDefinedControlsService = Meevo.Plugins.UserDefinedControls.UserDefinedControlsService;

    enum SavePlaceEnum {
        Tab,
        Service
    }

    class EditTabControlModalController {
        public appAreaTab: IAppAreaTab;
        public controls: Array<IUserDefinedControl>;
        public controlsCopy: Array<IUserDefinedControl>;
        public businessTypes: Array<IBusinessType>;
        public controlLocations: Object;
        public tabIsActive: boolean;
        public savePlace: SavePlaceEnum = SavePlaceEnum.Tab;
        public servicesSearchCriteria: Object;
        public selectedService: IAppAreaService;
        private serviceIsChanged: boolean = false;

        static $inject = [
            '$scope',
            '$q',
            '$mdDialog',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            'meevo.components.common.DataService',
            'meevo.plugins.userDefinedControls.userDefinedControlsService'
        ];

        constructor(
            protected $scope: ng.IScope,
            protected $q: ng.IQService,
            protected $mdDialog: ng.material.IDialogService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected userDefinedControlsService: Meevo.Plugins.UserDefinedControls.IUserDefinedControlsService
        ) {
            // define place for save
            if (this.appAreaTab.appAreaEnum === AppAreaEnum.Checkout || this.appAreaTab.appAreaEnum === AppAreaEnum.Booking
                || this.appAreaTab.appAreaEnum === AppAreaEnum.Checkin) {
                this.savePlace = SavePlaceEnum.Service;
                this.servicesSearchCriteria = {
                    'BusinessTypeId': this.appAreaTab.businessType_TId
                };

                // pre-populate selected service
                this.selectedService = {
                    objectStateEnum: ObjectStateEnum.Active,
                    id: this.appAreaTab.service_TId,
                    shortcut: this.appAreaTab.serviceShortcut,
                    displayName: this.appAreaTab.displayName
                };
            } else {
                this.savePlace = SavePlaceEnum.Tab;
            }

            this.busyService.start();
            this.$q.all([
                    this.getControlsByTabOrByService(),
                    this.getBusinessTypes()
                ])
                .finally(() => {
                    this.controls.map((item) => {
                        item['parsedControlTypeDisplay'] = UserDefinedControlsService.getControlTypeName(item.controlTypeEnum);
                    });

                    if (this.savePlace === SavePlaceEnum.Service) {
                        this.controlsCopy = angular.copy(this.controls);
                    }

                    this.busyService.stop();
                });

            this.controlLocations = this.userDefinedControlsService.controlLocations;
            this.tabIsActive = this.appAreaTab.objectStateEnum === ObjectStateEnum.Active;
            this.appAreaTab.businessType_TId = this.appAreaTab.businessType_TId || null;

            this.addWatchers();
        }

        /**
         * Add watchers to controller variables
         * */
        private addWatchers(): void {
            this.$scope.$watch(() => this.selectedService, this.serviceChanged.bind(this));
        }

        /**
         * Get controls by tab or by service
         * @returns {ng.IPromise<any>} promise
         * */
        getControlsByTabOrByService(): ng.IPromise<any> {
            let criteria: Object,
                url: string;

            if (this.savePlace == SavePlaceEnum.Service) {
                criteria = {
                    appAreaEnum: this.appAreaTab.appAreaEnum,
                    service_TId: this.selectedService.id
                };
            } else if (this.savePlace == SavePlaceEnum.Tab) {
                criteria = {
                    objectStateEnums: [ObjectStateEnum.Active, ObjectStateEnum.Inactive],
                    tab_TId: this.appAreaTab.tab_TId
                };
            }

            if (this.savePlace === SavePlaceEnum.Tab) {
                url = 'CustomData/Control';
            } else if (this.savePlace === SavePlaceEnum.Service) {
                url = `CustomData/Service/${this.selectedService.id}/Control`;
            }

            return this.dataService.getListPaged(url, {
                pageNumber: 0,
                itemsPerPage: 100000,
                sortBy: 'sortOrder',
                sortDirection: Meevo.Model.SortDirection.Ascending,
                criteria
            })
                .then((data: Array<IUserDefinedControl>|any) => {
                    if (this.savePlace == SavePlaceEnum.Service) {
                        if (this.serviceIsChanged) {
                            data.controls.map((item) => {
                                item['parsedControlTypeDisplay'] = UserDefinedControlsService.getControlTypeName(item.controlTypeEnum);
                            });

                            // check if selected service is the same as saved service
                            if (data.service_TId === this.appAreaTab.service_TId) {
                                this.controls = data.controls;
                            } else {
                                this.controls = this.controlsCopy.concat(data.controls);
                            }
                        } else {
                            this.controls = data.controls;
                        }
                    } else if (this.savePlace == SavePlaceEnum.Tab) {
                        this.controls = data;
                    }
                });
        }

        /**
         * Fetch list of business types
         * @returns {ng.IPromise<any>} promise
         * */
        private getBusinessTypes(): ng.IPromise<any> {
            let deferred = this.$q.defer();

            if (this.appAreaTab.appAreaEnum === AppAreaEnum.Client || this.appAreaTab.appAreaEnum === AppAreaEnum.Employee
                || this.savePlace === SavePlaceEnum.Service) {
                this.dataService.getListPaged('userbusinesstype', {
                    pageNumber: 0,
                    itemsPerPage: 100
                })
                    .then((data: Array<IBusinessType> | any) => {
                        data.forEach((item: IBusinessType) => {
                            if (item.id === '00000000-0000-0000-0000-000000000001') {
                                item.id = null;
                            }
                        });

                        this.businessTypes = data;
                        deferred.resolve();
                    })
                    .catch(() => {
                        deferred.reject();
                    });
            } else {
                deferred.resolve();
            }

            return deferred.promise;
        }

        /**
         * Close modal window
         * */
        public closeModal(): void {
            this.$mdDialog.cancel();
        };

        /**
         * Reorder controls
         * @param {IUserDefinedControl} control
         * @param {number} direction - available values 1, -1
         * */
        public moveControl(control: IUserDefinedControl, direction: number): void {
            let index = this.controls.indexOf(control);

            UserDefinedControlsService.moveItem(this.controls, index, index + direction);
        }

        /**
         * Change control state on tab, or even remove it
         * @param {IUserDefinedControl} control
         */
        public changeControlState(control: IUserDefinedControl): void {
            control.objectStateEnum = control.objectStateEnum === ObjectStateEnum.Active ? ObjectStateEnum.Inactive : ObjectStateEnum.Active;

            // disable ability to unassign UDFs from services and if it's already used
            if (!control.isUsed && this.savePlace !== SavePlaceEnum.Service) {
                control['isUnAssigned'] = true;
            }
        }

        /**
         * Check if a User can select Business Type
         * @returns {boolean}
         */
        public isBusinessTypeVisible(): boolean {
            return (this.businessTypes || []).length > 1 &&
                (
                    this.appAreaTab.appAreaEnum === AppAreaEnum.Employee ||
                    this.appAreaTab.appAreaEnum === AppAreaEnum.Client ||
                    this.appAreaTab.appAreaEnum === AppAreaEnum.Product ||
                    this.appAreaTab.appAreaEnum === AppAreaEnum.Service ||
                    this.savePlace === SavePlaceEnum.Service
                );
        }

        /**
         * Perform checks before assignment
         * */
        public tryToUpdate() {
            if (this.savePlace === SavePlaceEnum.Tab) {
                if (!this.appAreaTab.displayName) {
                    return;
                }
            } else if (this.savePlace === SavePlaceEnum.Service) {
                if (!this.selectedService) {
                    return;
                }
            }

            if (!this.appAreaTab.isMain) {
                this.appAreaTab.objectStateEnum = this.tabIsActive ? ObjectStateEnum.Active : ObjectStateEnum.Inactive;
            }

            this.updateTab();
        }

        private prepareData() {
            let data: Object = {
                controls: this.controls
            };

            if (this.savePlace === SavePlaceEnum.Tab) {
                angular.extend(data, {
                    tab: this.appAreaTab
                });
            } else if (this.savePlace === SavePlaceEnum.Service) {
                angular.extend(data, {
                    appAreaEnum: this.appAreaTab.appAreaEnum,
                    objectStateEnum: this.appAreaTab.objectStateEnum,
                    service_TId: this.selectedService.id
                });
            }

            return data;
        }

        /**
         * Update Tab
         * */
        private updateTab(): void {
            this.controls.map((item, index) => {
                item['sortOrder'] = index;
            });

            this.busyService.start();
            this.dataService.add(`CustomData/${SavePlaceEnum[this.savePlace]}`, this.prepareData())
                .then((response) => {
                    if (response['isWarning']) {
                        this.modalService
                            .alert(response.responseStatus.message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                    } else {
                        this.$mdDialog.hide();
                    }
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * User selects another service from typeAhead control
         * @param {IAppAreaService} newService
         * @param {IAppAreaService} prevService
         */
        private serviceChanged(newService: IAppAreaService, prevService: IAppAreaService): void {
            // avoid useless changes
            if (newService === prevService) {
                return;
            }

            // check if service isn't selected
            if (!newService) {
                this.controls = this.controlsCopy;
                return;
            }

            this.serviceIsChanged = true;
            this.getControlsByTabOrByService();
        }

        get appAreaEnum(): any {
            return AppAreaEnum;
        }

        get SavePlaceEnum(): any {
            return SavePlaceEnum;
        }

        get objectStateEnum(): any {
            return ObjectStateEnum;
        }
    }

    angular.module('meevo.plugins.userDefinedControls')
        .controller('meevo.plugins.userDefinedControls.EditTabControlModalController', EditTabControlModalController);
}
